import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import Dropdown from 'components/base/Dropdown'
import { IncentiveBoxLayout } from 'components/Utils/IncentiveBox/Layout'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

export default class SelectRoleWrapper extends Component {
  static propTypes = {
    roles: PropTypes.any.isRequired,
    onSelectRole: PropTypes.func.isRequired,
    position: PropTypes.string,
    align: PropTypes.string,
    bodyProps: PropTypes.any,
    onIsOpenChange: PropTypes.func,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    position: 'bottom',
    align: 'start',
  }

  render() {
    if (this.props.disabled) {
      return this.props.children
    }
    return (
      <PopoverOnClick
        content={this.renderContent}
        position={this.props.position}
        align={this.props.align}
        onIsOpenChange={this.props.onIsOpenChange}
      >
        {this.props.children}
      </PopoverOnClick>
    )
  }

  onClick = (role, closePopover, key) => {
    if (role.disabled) {
      const { goToOrganizationUpgrade } = this.props

      return goToOrganizationUpgrade('ManageDefaultRole')
    }
    closePopover()
    this.props.onSelectRole(key)
  }

  renderContent = ({ closePopover }) => {
    return (
      <Dropdown.Body
        placement={this.props.popoverPlacement}
        {...this.props.bodyProps}
      >
        {Object.keys(this.props.roles).map(key => {
          const role = this.props.roles[key]
          return (
            <Dropdown.Item
              onClick={() => this.onClick(role, closePopover, key)}
              key={key}
              className="padding-vertical-medium"
              style={{
                lineHeight: 'inherit',
              }}
            >
              <div className="flexbox flexbox-align-center">
                <div
                  className={classNames('margin-bottom-smaller', 'shade-05 ')}
                >
                  {role.title}
                </div>
                {role.disabled && (
                  <TooltipOnHover
                    id="tooltip-private-channel-upgrade"
                    placement="top"
                    delayShow={100}
                    tooltipContent="Click to learn more"
                  >
                    <div className="margin-bottom-smaller">
                      <IncentiveBoxLayout
                        incentiveId="ManageDefaultRole"
                        className="margin-horizontal-small"
                        goToOrganizationUpgrade={
                          this.props.goToOrganizationUpgrade
                        }
                        organizationIsFree={this.props.organizationIsFree}
                      />
                    </div>
                  </TooltipOnHover>
                )}
              </div>
              <div className={classNames('font-weight-regular', 'shade-20')}>
                {role.description}
              </div>
            </Dropdown.Item>
          )
        })}
      </Dropdown.Body>
    )
  }
}
